import { render, staticRenderFns } from "./OrdersViewModal.vue?vue&type=template&id=8daaa722&"
import script from "./OrdersViewModal.vue?vue&type=script&lang=js&"
export * from "./OrdersViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports